import { useRef, useState, type ReactNode } from "react";
import type { Posture } from "@/lib/api";
import { storedOnboardingPosture } from "@/lib/posture";
import { PreviewContext, type Suggestions } from "./preview-context";

function detectTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function PreviewProvider({ children }: { children: ReactNode }) {
  const [orgName, setOrgName] = useState("");
  const [orgWebsite, setOrgWebsite] = useState("");
  const [agentName, setAgentName] = useState("");
  const [orgInfo, setOrgInfo] = useState("");
  const [posture, setPosture] = useState<Posture>(() => storedOnboardingPosture() ?? "teammate");
  const [timeZone, setTimeZone] = useState(detectTimeZone);
  const [briefingTime, setBriefingTime] = useState("08:00");
  const [suggestedWebsite, setSuggestedWebsite] = useState<string | null>(null);
  const suggestionsApplied = useRef(false);

  function applySuggestions(s: Suggestions) {
    if (suggestionsApplied.current) return;
    suggestionsApplied.current = true;
    if (s.orgWebsite) setSuggestedWebsite(s.orgWebsite);
    if (s.orgName && !orgName) setOrgName(s.orgName);
    if (s.orgWebsite && !orgWebsite) setOrgWebsite(s.orgWebsite);
    if (s.agentName && !agentName) setAgentName(s.agentName);
    if (s.orgInfo) setOrgInfo(s.orgInfo);
  }

  return (
    <PreviewContext.Provider
      value={{
        orgName,
        orgWebsite,
        agentName,
        orgInfo,
        posture,
        timeZone,
        briefingTime,
        suggestedWebsite,
        setOrgName,
        setOrgWebsite,
        setAgentName,
        setOrgInfo,
        setPosture,
        setTimeZone,
        setBriefingTime,
        applySuggestions,
      }}
    >
      {children}
    </PreviewContext.Provider>
  );
}
